var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgSurvey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 64,
    viewBox: "0 0 102 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 44,
    height: 50,
    rx: 3,
    fill: "#E6F0F7",
    stroke: "#BDD0DD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 27.5C54.8284 27.5 55.5 28.1716 55.5 29C55.5 29.8284 54.8284 30.5 54 30.5H38C37.1716 30.5 36.5 29.8284 36.5 29C36.5 28.1716 37.1716 27.5 38 27.5H54ZM66 20.5C66.8284 20.5 67.5 21.1716 67.5 22C67.5 22.8284 66.8284 23.5 66 23.5H38C37.1716 23.5 36.5 22.8284 36.5 22C36.5 21.1716 37.1716 20.5 38 20.5H66Z",
    fill: "#6981BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.776 6.8L45.856 4.664C46.672 3.032 48.328 2 50.152 2H53.824C55.648 2 57.304 3.032 58.12 4.664L59.2 6.8H61.6C62.92 6.8 64 7.88 64 9.2V11.6C64 12.92 62.92 14 61.6 14H42.4C41.08 14 40 12.92 40 11.6V9.2C40 7.88 41.08 6.8 42.4 6.8H44.8H44.776Z",
    fill: "#6981BE",
    stroke: "#415DA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6237 38.2289C26.7776 37.9237 27.2224 37.9237 27.3763 38.2289L29.3688 42.1796C29.43 42.3008 29.5481 42.3848 29.6848 42.4042L34.1403 43.0378C34.4844 43.0867 34.6219 43.5006 34.3728 43.7381L31.1488 46.8134C31.0499 46.9077 31.0048 47.0436 31.0281 47.1768L31.7892 51.5191C31.848 51.8545 31.4882 52.1103 31.1804 51.9519L27.1953 49.9018C27.073 49.8389 26.927 49.8389 26.8047 49.9018L22.8196 51.9519C22.5118 52.1103 22.152 51.8545 22.2108 51.5191L22.9719 47.1768C22.9952 47.0436 22.9501 46.9077 22.8512 46.8134L19.6272 43.7381C19.3781 43.5006 19.5156 43.0867 19.8597 43.0378L24.3152 42.4042C24.4519 42.3848 24.57 42.3008 24.6312 42.1796L26.6237 38.2289Z",
    fill: "#FFB728",
    stroke: "#E29D12",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.423 34.3597C51.659 33.8801 52.341 33.8801 52.577 34.3597L55.6322 40.568C55.7259 40.7584 55.9071 40.8904 56.1167 40.9209L62.9484 41.9165C63.4761 41.9934 63.6869 42.6438 63.305 43.0171L58.3615 47.8496C58.2099 47.9978 58.1407 48.2114 58.1765 48.4207L59.3435 55.2442C59.4336 55.7713 58.8819 56.1733 58.4099 55.9244L52.2994 52.7028C52.112 52.604 51.888 52.604 51.7006 52.7028L45.5901 55.9244C45.1181 56.1733 44.5664 55.7713 44.6565 55.2442L45.8235 48.4207C45.8593 48.2114 45.7901 47.9978 45.6385 47.8496L40.695 43.0171C40.3131 42.6438 40.5239 41.9934 41.0516 41.9165L47.8833 40.9209C48.0929 40.8904 48.2741 40.7584 48.3678 40.568L51.423 34.3597Z",
    fill: "#FFB728",
    stroke: "#E29D12",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1488 38.2289C76.2925 37.9237 76.7075 37.9237 76.8512 38.2289L78.7109 42.1796C78.768 42.3008 78.8782 42.3848 79.0058 42.4042L83.1642 43.0378C83.4855 43.0867 83.6137 43.5006 83.3813 43.7381L80.3722 46.8134C80.2799 46.9077 80.2378 47.0436 80.2596 47.1768L80.9699 51.5191C81.0248 51.8545 80.689 52.1103 80.4017 51.9519L76.6822 49.9018C76.5682 49.8389 76.4318 49.8389 76.3178 49.9018L72.5983 51.9519C72.311 52.1103 71.9752 51.8545 72.0301 51.5191L72.7404 47.1768C72.7622 47.0436 72.7201 46.9077 72.6278 46.8134L69.6187 43.7381C69.3863 43.5006 69.5145 43.0867 69.8358 43.0378L73.9942 42.4042C74.1218 42.3848 74.232 42.3008 74.2891 42.1796L76.1488 38.2289Z",
    fill: "#D3DCFB",
    stroke: "#ADBBEB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSurvey);
export default __webpack_public_path__ + "static/media/img_survey.3e7d68adcb3d302fd32686b155454eaa.svg";
export { ForwardRef as ReactComponent };